module.exports = __webpack_public_path__ + "img/paintbrush.b4203b7a.svg";